import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface ImageCarouselProps {
  images: {
    src: string;
    alt: string;
  }[];
}
export function ImageCarousel({
  images
}: ImageCarouselProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const goToPrevious = () => {
    setCurrentIndex(prevIndex => prevIndex === 0 ? images.length - 1 : prevIndex - 1);
  };
  const goToNext = () => {
    setCurrentIndex(prevIndex => prevIndex === images.length - 1 ? 0 : prevIndex + 1);
  };
  return <div className="relative max-w-3xl mx-auto" data-id="element-326">
      <div className="relative aspect-[4/3] bg-white rounded-lg overflow-hidden shadow-xl" data-id="element-327">
        <img src={images[currentIndex].src} alt={images[currentIndex].alt} className="w-full h-full object-contain" data-id="element-328" />
      </div>

      <button onClick={goToPrevious} className="absolute left-2 top-1/2 -translate-y-1/2 bg-[#2C3E50] hover:bg-[#27AE60] text-white p-2 rounded-full shadow-lg transition-colors" aria-label="Imagen anterior" data-id="element-329">
        <ChevronLeftIcon className="w-6 h-6" data-id="element-330" />
      </button>

      <button onClick={goToNext} className="absolute right-2 top-1/2 -translate-y-1/2 bg-[#2C3E50] hover:bg-[#27AE60] text-white p-2 rounded-full shadow-lg transition-colors" aria-label="Siguiente imagen" data-id="element-331">
        <ChevronRightIcon className="w-6 h-6" data-id="element-332" />
      </button>

      <div className="flex justify-center gap-2 mt-4" data-id="element-333">
        {images.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`w-2 h-2 rounded-full transition-all ${index === currentIndex ? 'bg-[#27AE60] w-8' : 'bg-gray-300 hover:bg-gray-400'}`} aria-label={`Ir a imagen ${index + 1}`} data-id="element-334" />)}
      </div>

      <p className="text-center text-sm text-gray-400 mt-2" data-id="element-335">
        {currentIndex + 1} / {images.length}
      </p>
    </div>;
}